import * as React from 'react';
import CloseIcon from '@mui/icons-material/Close';
import {
  Dialog,
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Slide,
  DialogContent
} from '@mui/material';
import LogDataPlot from './LogDataPlot';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const LogPlotDialog = ({ open, onClose, tableId, category, auth, onLogout }) => {
  // console.log("Table ID in Dialog:", tableId);

  return (
      <Dialog
        fullScreen
        open={open}
        onClose={onClose}
        slots={{
          transition: Transition,
        }}
      >
        <AppBar sx={{ position: 'relative' }}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={onClose}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
                Plotting Data from  {tableId ? `Table ID :- ${tableId}` : ""}
            </Typography>
          </Toolbar>
        </AppBar>
        <DialogContent>
            <LogDataPlot
              tableId={tableId}
              category={category}
              auth={auth}
              onLogout={onLogout} />
        </DialogContent>
      </Dialog>
  );
};

export default LogPlotDialog;
